const DummyData = {
	contestWithUsers: {
		contest: {
			name: 'AWESOME CONTEST!!',
			contest_type: 'members',
			prize_name: 'Two days off',
			prize_image: 'img/money.jpg',
		},
		organization: {
			name: 'ACME Inc.',
			logo: 'img/logo.png',
		},
		target: {
			text: 'First person to reach 10k',
			value: 10000,
			formatted_value: '10,000 kr.',
		},
		items: [{
			id: 'uuid1',
			name: 'Bruce Willis',
			avatar: 'img/bruce1.jpg',
			target: {
				value: 12000,
				formatted_value: '12,000 kr.',
			},
		}, {
			id: 'uuid2',
			name: 'Brad Pitt',
			avatar: 'img/brad.jpg',
		}, {
			id: 'uuid3',
			name: 'Yvonne Strahovski',
			avatar: 'img/yvonne.jpg',
		}, {
			id: 'uuid4',
			name: 'Bruce Willis 2',
			avatar: 'img/bruce.jpg',
			target: {
				value: 12000,
				formatted_value: '12,000 kr.',
			},
		}, {
			id: 'uuid5',
			name: 'Brad Pitt 2',
			avatar: 'img/brad.jpg',
		}, {
			id: 'uuid6',
			name: 'Yvonne Strahovski 2',
		}],
	},
	contestWithTeams: {
		contest: {
			title: 'AWESOME CONTEST!!',
			prize: 'Two days off',
			type: 'teams',
			image: 'img/money.jpg',
		},
		organization: {
			name: 'ACME Inc.',
			logo: 'img/logo.png',
		},
		target: {
			text: 'First person to reach 10k',
			value: 10000,
			formatted_value: '10,000 kr.',
		},
		items: [{
			id: 'uuid1',
			name: 'Team UK',
			avatar: 'img/uk.jpg',
			target: {
				value: 120000,
				formatted_value: '120,000 kr.',
			},
			members: [{
				id: 'uuid1',
				name: 'Bruce Willis',
				avatar: 'img/bruce.jpg',
			}, {
				id: 'uuid2',
				name: 'Brad Pitt',
				avatar: 'img/brad.jpg',
			}, {
				id: 'uuid3',
				name: 'Yvonne Strahovski',
				avatar: 'img/yvonne.jpg',
			}, {
				id: 'uuid4',
				name: 'Bruce Willis',
				avatar: 'img/bruce.jpg',
			}, {
				id: 'uuid5',
				name: 'Brad Pitt',
				avatar: 'img/brad.jpg',
			}, {
				id: 'uuid6',
				name: 'Yvonne Strahovski',
				avatar: 'img/yvonne.jpg',
			}, {
				id: 'uuid7',
				name: 'Bruce Willis',
				avatar: 'img/bruce.jpg',
			}, {
				id: 'uuid8',
				name: 'Brad Pitt',
				avatar: 'img/brad.jpg',
			}, {
				id: 'uuid9',
				name: 'Yvonne Strahovski',
				avatar: 'img/yvonne.jpg',
			}],
		}, {
			id: 'uuid1',
			name: 'Team US',
			avatar: 'img/us.jpg',
			target: {
				value: 195000,
				formatted_value: '195,000 kr.',
			},
			members: [{
				id: 'uuid1',
				name: 'Bruce Willis',
				avatar: 'img/bruce.jpg',
			}, {
				id: 'uuid2',
				name: 'Brad Pitt',
				avatar: 'img/brad.jpg',
			}, {
				id: 'uuid3',
				name: 'Yvonne Strahovski',
				avatar: 'img/yvonne.jpg',
			}],
		}, {
			id: 'uuid1',
			name: 'Team SE',
			avatar: 'img/se.jpg',
			target: {
				value: 80000,
				formatted_value: '80,000 kr.',
			},
			members: [{
				id: 'uuid1',
				name: 'Bruce Willis',
				avatar: 'img/bruce.jpg',
			}, {
				id: 'uuid2',
				name: 'Brad Pitt',
				avatar: 'img/brad.jpg',
			}, {
				id: 'uuid3',
				name: 'Yvonne Strahovski',
				avatar: 'img/yvonne.jpg',
			}],
		}, {
			id: 'uuid1',
			name: 'Team DK',
			avatar: 'img/dk.jpg',
			target: {
				value: 60000,
				formatted_value: '60,000 kr.',
			},
			members: [{
				id: 'uuid1',
				name: 'Bruce Willis',
				avatar: 'img/bruce.jpg',
			}, {
				id: 'uuid2',
				name: 'Brad Pitt',
				avatar: 'img/brad.jpg',
			}, {
				id: 'uuid3',
				name: 'Yvonne Strahovski',
				avatar: 'img/yvonne.jpg',
			}],
		}, {
			id: 'uuid1',
			name: 'Team NO',
			avatar: 'img/no.jpg',
			target: {
				value: 60000,
				formatted_value: '60,000 kr.',
			},
			members: [{
				id: 'uuid1',
				name: 'Bruce Willis',
				avatar: 'img/bruce.jpg',
			}, {
				id: 'uuid2',
				name: 'Brad Pitt',
				avatar: 'img/brad.jpg',
			}, {
				id: 'uuid3',
				name: 'Yvonne Strahovski',
				avatar: 'img/yvonne.jpg',
			}],
		}, {
			id: 'uuid1',
			name: 'Team SE 2',
			avatar: 'img/se.jpg',
			target: {
				value: 80000,
				formatted_value: '80,000 kr.',
			},
			members: [{
				id: 'uuid1',
				name: 'Bruce Willis',
				avatar: 'img/bruce.jpg',
			}, {
				id: 'uuid2',
				name: 'Brad Pitt',
				avatar: 'img/brad.jpg',
			}, {
				id: 'uuid3',
				name: 'Yvonne Strahovski',
				avatar: 'img/yvonne.jpg',
			}],
		}, {
			id: 'uuid1',
			name: 'Team DK 2',
			avatar: 'img/dk.jpg',
			target: {
				value: 60000,
				formatted_value: '60,000 kr.',
			},
			members: [{
				id: 'uuid1',
				name: 'Bruce Willis',
				avatar: 'img/bruce.jpg',
			}, {
				id: 'uuid2',
				name: 'Brad Pitt',
				avatar: 'img/brad.jpg',
			}, {
				id: 'uuid3',
				name: 'Yvonne Strahovski',
				avatar: 'img/yvonne.jpg',
			}],
		}, {
			id: 'uuid1',
			name: 'Team NO 2',
			avatar: 'img/no.jpg',
			target: {
				value: 60000,
				formatted_value: '60,000 kr.',
			},
			members: [{
				id: 'uuid1',
				name: 'Bruce Willis',
				avatar: 'img/bruce.jpg',
			}, {
				id: 'uuid2',
				name: 'Brad Pitt',
				avatar: 'img/brad.jpg',
			}, {
				id: 'uuid3',
				name: 'Yvonne Strahovski',
				avatar: 'img/yvonne.jpg',
			}],
		}],
	},
};

export default DummyData;
